import React, { forwardRef, useEffect, useRef } from 'react';
import { useAuth } from '@clerk/clerk-react';
import './MessageArea.css';
import ModelViewer from './ModelViewer';

const MessageArea = forwardRef(({ messages, loading, fileFormat }, ref) => {
  const chatboxRef = useRef(null);
  const { getToken } = useAuth();

  // Scroll to bottom when messages change
  useEffect(() => {
    if (chatboxRef.current) {
      chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
    }
  }, [messages]);

  // Set ref from parent component
  useEffect(() => {
    if (ref) {
      ref.current = chatboxRef.current;
    }
  }, [ref]);

  const downloadFile = async (objectId) => {
    try {
      // Get authentication token using Clerk's useAuth hook
      const token = await getToken();
      if (!token) {
        console.error('No authentication token available');
        return;
      }

      console.log('Requesting download with auth token');
      const response = await fetch(`/download_stl/${objectId}/${fileFormat}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        console.log('Download response:', data);
        // Redirect to the signed URL for download
        if (data.download_url) {
          window.location.href = data.download_url;
        } else {
          console.error('Download URL not found in response');
        }
      } else {
        console.error('Error downloading file:', await response.text());
      }
    } catch (error) {
      console.error('Error during file download:', error);
    }
  };

  return (
    <div className="chatbox" ref={chatboxRef}>
      {messages
        .filter(message => message.role !== 'system') // Filter out system messages
        .map((message, index) => (
          <div
            key={index}
            className={message.role === 'user' ? 'userText' : 'botText'}
          >
            <span>
              {message.stlFile && (
                <div className="stl-wrapper">
                  <ModelViewer
                    stlFile={message.stlFile}
                    objectId={message.objectId}
                    onDownload={() => downloadFile(message.objectId)}
                  />
                  {message.generationTime && (
                    <div className="generation-time">
                      Time to generate: {message.generationTime}s
                    </div>
                  )}
                </div>
              )}
              {message.role === 'user' && message.content}
            </span>
          </div>
        ))}

      {loading && (
        <div className="botText" id="botSpinner">
          <div className="spinner"></div>
        </div>
      )}
    </div>
  );
});

export default MessageArea;